module.exports = __webpack_public_path__ + "img/1MenuActivateIT.e05896db.png";